import request from '@/utils/request'

//
export function createDepartment(query) {
  return request({
    url: '/role',
    method: 'post',
    data: query
  })
}

export function editDepartment(id, query) {
  return request({
    url: '/role/edit/' + id,
    method: 'post',
    data: query
  })
}

export function searchDepartment() {
  return request({
    url: '/role/search',
    method: 'post'

  })
}

export function deleteDepartment(id) {
  return request({
    url: '/role/delete/' + id,
    method: 'get'

  })
}

